module.exports = __webpack_public_path__ + "img/2.576d9d07.png";